import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import GitInfo from 'react-git-info/macro';

const gitInfo = GitInfo();

export default () => {
  return (
    <>
      <h1>Git Info</h1>
      <p>
        Commit Hash: <strong>{gitInfo.commit.shortHash}</strong>
      </p>
      <p>
        Commit Date: <strong>{gitInfo.commit.date}</strong>
      </p>
    </>
  );
};
